// extracted by mini-css-extract-plugin
export default {"overlay":"hB-z","bodyOpen":"iB-z","content":"jB-z","header":"kB-z","close":"lB-z","closeNoHeading":"mB-z"};